<template>
  <div>
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-toolbar>
        <span class="md-title">Siniestros no aprobados</span>
      </md-toolbar>
      <md-content class="md-scrollbar">
      <md-card>
        <md-card-content>
          <md-table>
            <md-table-row>
              <md-table-head
                v-for="(header, index) in tableHeaders"
                :key="index"
              > {{ header.text }} </md-table-head>
              <md-table-head> Concepto de rechazo </md-table-head>
            </md-table-row>
            <md-table-row v-for="item in sinisterNotSelected" :key="item.id">
              <template v-for="(header, index) in tableHeaders">
                <md-table-cell
                  :md-label="header.text" :key="index"
                > {{ item.sinister.sinisterNumber }} </md-table-cell>

              </template>
              <md-table-cell md-label="Acciones">
                <md-field>
                  <label>Concepto</label>
                  <md-input v-model="item.message" placeholder="Escribe el mensaje"></md-input>
                </md-field>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
      </md-content>
      <md-card-header v-if="isCheck">
        <div class="md-caption md-plain">*Es necesario llenar todos los campos</div>
      </md-card-header>
      <md-dialog-actions>
        <md-button class="md-primary" @click="CloseDialog">Cancelar</md-button>
        <md-button class="md-primary" @click="sendMessageData" :disabled="activeButton">Guardar</md-button>
      </md-dialog-actions>
    </md-dialog>

  </div>
</template>

<script>
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: () => false
      },
      sinisterNotSelected: {
        type: Array,
        default: () => []
      }
    },
    name: 'DialogCustom',
    data: () => ({
      tableHeaders: [
        { text: 'Siniestro', value: 'sinisterNumber' },
      ],
      message: '',
      rejectedSinisters: [],
      isCheck: false
    }),
    methods: {
      CloseDialog () {
        this.isCheck = false
        this.$emit('CloseDialog')
      },
      sendMessageData () {
        if (this.checkFilds()) {
          this.isCheck = true
        } else {
          this.rejectedSinisters = this.groupSinister()
          this.isCheck = false
          this.$emit('sendSinisterData', this.rejectedSinisters)
        }
      },
      groupSinister () {
        let sinister = []
        for (let item of this.sinisterNotSelected) {
          sinister.push({
            sinister: item.sinister.id,
            message: item.message
          })
        }
        return sinister
      },
      checkFilds () {
        let flag = false
        for (let item of this.sinisterNotSelected) {
          if (item.message !== null && item.message !== '') {
            flag = false
          } else {
            flag = true
          }
        }
        return flag
      }
    },
    computed: {
      activeButton () {
        return false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .md-dialog .md-dialog-container {
    max-width: 768px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/extranet/DialogNotSinister.vue